export const validEmail = new RegExp(
    '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Z|a-z]{2,}$'
);

export const validContactNumber = new RegExp(
    // "^(\\d{5}-\\d{3}-\\d{3}_|\\d{5}-\\d{3}-\\d{4})$"
    "^(\\+?\\d{10,15}|\\d{5}-\\d{3}-\\d{3}_|\\d{5}-\\d{3}-\\d{4})$"
)

export const isValidContactNumber = (number) => {
    return validContactNumber.test(number);
}

export const isNumber = new RegExp("^\\d*$");

export const resetErrorFieldStyle = (e) => {
    if (e.target.classList.contains("invalid-Credentials")) {
        e.target.classList.remove("invalid-Credentials")
    } else if (e.target.classList.contains("invalid-details")) {
        e.target.classList.remove("invalid-details")
    }
}

export const txtFormatChecker = (file) => {
    let isText = false;
    if (file) {
        const fileType = file.type;
        if (fileType !== 'text/plain') {
            isText = false;
        }
        else {
            isText = true;
        }
    }
    return isText;
}

// export const handleContactNumber = (event) => {
//     const array = ["Backspace", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
//     if (!isNumber.test(event.key) && !array.includes(event.key)) {
//         event.preventDefault();
//     }
// };

export const handleContactNumber = (event) => {
    const allowedKeys = [
        "Backspace", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Tab"
    ];

    // Allow copy/paste/select operations using Ctrl or Cmd
    if (event.ctrlKey || event.metaKey) return;

    if (!isNumber.test(event.key) && !allowedKeys.includes(event.key)) {
        event.preventDefault();
    }
};

export const handleInput = (event) => {
    const value = event.target.value;
    event.target.value = value.replace(/\D/g, ""); // Remove non-numeric characters
};


// export const resetErrorFieldStyleOnBoarding = (e) => {
//     if (e.target.classList.contains("invalid-details")) {
//         e.target.classList.remove("invalid-details")
//     }
// }

export const getUserLicenseDetails = async (requestType, token, practiceId, setIsTokenExpired, setOutBoundLeadsDetail) => {
    let url = `/api/getOutBoundLeadDetails`;
    let obj = { "practiceId": practiceId };
    const userData = await requestType(token, url, obj);
    if (userData == "Token is expired, login again") {
        setIsTokenExpired(true)
    }
    else {
        setOutBoundLeadsDetail(userData)
    }
}

export const currentMemberListName = (activeTab) => {
    let memberListName = "";
    if (activeTab === "inBoundCalls") {
        memberListName = "InboundCallsUploadLead";
    } else if (activeTab === "leadGTab") {
        memberListName = "LeadGenerationUploadLead";
    }
    return memberListName;
}

export const currentAPIAndMemberList = (activeTab, PracticeId) => {
    let url, memberList;
    debugger
    if (activeTab === "inBoundCalls") {
        url = `/api/PAuthQOnBoardingTemplate/${PracticeId}`;
        memberList = "InboundCalls";
    }
    else if (activeTab === "leadGTab") {
        url = `/api/LeadGenerationOnboarding/${PracticeId}`;
        memberList = "LeadGeneration";
    }
    return { url, memberList }
}
